/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import { Container, Button, Image } from 'react-bootstrap';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useStore } from 'store';
import { setCurrentStep, saveGiftTables } from 'store/actions/giftTableFlow';
import { TYPE_ID } from 'constants/values/giftTable';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { AGENT_STAFF } from 'constants/storage64';
import {  useStorage64 , useWindowSize } from 'hooks';
import { ErrorModal } from 'components';
import { useHistory } from 'react-router-dom';
import giftIcon from 'assets/img/iconregalo.svg';
import { useUserInfo } from '../Header/Content/hooks/usePersonalData';
import {
  LIST_OF_STEPS,
  LIST_OF_STEPS_NOW,
  IN_RIGHT_ANIMATION,
  OUT_LEFT_ANIMATION,
  IN_LEFT_ANIMATION,
  OUT_RIGHT_ANIMATION,
  DELAY_TIME,
} from './config';
import 'animate.css/animate.min.css';
import './index.scss';
import { ro } from 'date-fns/locale';
import { transform } from 'lodash';

const TableFlow = () => {
  const { profileGet: profileData } = useUserInfo();
  const [stepInfo, setStepInfo] = useState({});
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [animation, setAnimation] = useState(IN_RIGHT_ANIMATION);

  const [giftTableFlow, dispatch] = useStore((state) => state.giftTableFlow);

  const [chanteStep, setChanteStep ] = useState()

  const { currentStep = 1, selectedEventType } = giftTableFlow;

  // config flow to steps
  const [steps, setSteps] = useState(LIST_OF_STEPS);
  const [getPlan, setPlan] = useState();
  // start with the first step
  const initialStep = steps[currentStep - 1];
  const [activeStep, setActiveStep] = useState(initialStep);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [lastStep, setLastStep] = useState(false);

  // gets agentId from store
  const [agentStaffId] = useStore(
    (state) => state.commons.agentStaffId
  );
  const [, setAgentStaffID] = useStorage64(AGENT_STAFF, '');
  const [, { isMobile }] = useWindowSize();

  useEffect(() => {
    if (agentStaffId) {
      setAgentStaffID(agentStaffId);
    }
  }, [agentStaffId]);

  useEffect(() => {
    window.scrollTo(0, 0);
    // console.clear();
    if(activeStep){
      // console.log('activeStep', activeStep);
    }
  }, [activeStep]);

  const handleNext = () => {
    if (steps[steps.length - 1].key !== activeStep.key) {
      setAnimation(OUT_LEFT_ANIMATION);
    }
    /*
    if(!activeStep.key){
      setActiveStep(steps[0]);
      dispatch(setCurrentStep(1));
    }
    */
    const onClickNext = () => {
      // is the last step
      if (steps[steps.length - 1].key === activeStep.key) {
        // TODO implement logic to redirect to new landing
        console.log('You have completed all steps redirect to select gifts');
        setLastStep(true);
        return;
      }
      // getting index of the current step
      const index = steps.findIndex((step) => step.key === activeStep.key);
      // TODO review logic when the form is ok
      setSteps((prevStep) =>
        prevStep.map((x) => {
          if (x.key === activeStep.key) x.isDone = true;
          return x;
        })
      );

      setActiveStep(steps[index + 1]);
      dispatch(setCurrentStep(currentStep + 1));

      setAnimation(IN_RIGHT_ANIMATION);
    };

    setTimeout(onClickNext, DELAY_TIME);
  };

  const handleBack = () => {
    setAnimation(OUT_RIGHT_ANIMATION);

    const onClickBack = () => {
      const index = steps.findIndex((x) => x.key === activeStep.key);
      if (index === 0) return; // if the step is the first

      // TODO review this logic if the form is ok
      setSteps((prevStep) =>
        prevStep.map((x) => {
          if (x.key === activeStep.key) x.isDone = false;
          return x;
        })
      );

      setActiveStep(steps[index - 1]); // update active step to the next
      dispatch(setCurrentStep(currentStep - 1));

      setAnimation(IN_LEFT_ANIMATION);
    };

    setTimeout(onClickBack, DELAY_TIME);
  };

  const history = useHistory();

  const handleBackPage = () => {
    history.goBack();
  }

  const onSaveDataHandler = (data, stepKey = activeStep.key) => {

    // console.log('************onSaveDataHandler***********')
    // console.log('TableFlow - onSaveDataHandler data: ',data)
    // console.log('TableFlow - onSaveDataHandler stepKey: ',stepKey)

    const newData = {
      ...stepInfo,
      [stepKey]: data,
    };

    setStepInfo(newData);
  };

  useEffect(() => {
    if (selectedEventType) {
      const eventTypeData = {
        celebration: selectedEventType.eventTypeName,
        category: selectedEventType,
        valid: selectedEventType?.eventTypeName && !_isEmpty(selectedEventType),
      };
      onSaveDataHandler(eventTypeData, steps[0].key);
    }
  }, []);

  const onSaveError = () => {
    setLastStep(false);
  };

  const handlerPlan = (plan) => setPlan(plan);

  useEffect(() => {
    // console.log('+++++++++++++++ESTOY ACA+++++++++++++++')
    // setAnimation(OUT_RIGHT_ANIMATION);
    if (steps[steps.length - 1].key !== activeStep.key) {
      setAnimation(OUT_LEFT_ANIMATION);
    }
    // console.log('+++++++++++++++ESTOY ACA+++++++++++++++')
    const changePlan  = () => {
      // console.log('+++++++++++++++ESTOY ACA+++++++++++++++')
      if (Object.keys(stepInfo).length > 0){
        // console.log('+++++++++++++++ESTOY ACA+++++++++++++++')

        if (getPlan === 1 ) {
          setSteps(LIST_OF_STEPS_NOW);
          // console.log(LIST_OF_STEPS_NOW)
          setActiveStep(LIST_OF_STEPS_NOW[2]);
          dispatch(setCurrentStep(3));
        }
        if (getPlan === 2 ) {
          setSteps(LIST_OF_STEPS);
          // console.log(LIST_OF_STEPS)
          setActiveStep(LIST_OF_STEPS[2]);
          dispatch(setCurrentStep(3));
        }
        if (getPlan === 0 ) {
          // console.log('+++++++++++++++ESTOY ACA+++++++++++++++')
          setSteps(LIST_OF_STEPS);
          // console.log(LIST_OF_STEPS)
          setActiveStep(LIST_OF_STEPS[0]);
          dispatch(setCurrentStep(0));
        }
      }
      // console.log('+++++++++++++++ESTOY ACA+++++++++++++++')
      onSaveDataHandler({
        plan:getPlan,
        valid: true
      });

      // getting index of the current step
      const index = steps.findIndex((step) => step.key === activeStep.key);
      // TODO review logic when the form is ok
      setSteps((prevStep) =>
        prevStep.map((x) => {
          if (x.key === activeStep.key) x.isDone = true;
          return x;
        })
      );
      // console.log('+++++++++++++++ESTOY ACA+++++++++++++++')
      setAnimation(IN_RIGHT_ANIMATION);
    };

    setTimeout(changePlan, DELAY_TIME);
  }, [getPlan]);


  useEffect(() => { 
    if (stepInfo.guests && lastStep) {
      const {
        select_event,
        select_plan,
        celebrated,
        address,
        special_date,
        guests,
      } = stepInfo;

      const celebrate = celebrated.celebrate_labels.map((person) =>
        select_event.category.id === 2 || select_event.category.id === 1
          ? person.is_responsable && celebrated.celebrate_labels[2]
            ? null
            : person.name === celebrated.celebrate_labels[1].name
            ? ` & ${person.name}`
            : person.name
          : person.is_responsable && celebrated.celebrate_labels[1]
          ? null
          : person.name
      );

      const planSelected = select_plan.plan !== 1;

      const giftTableName = `Te invito a mi ${
        select_event.category.label || select_event.category.name
      } - ${celebrate.join('')}`;

      const saveTableBody = {
        customer: {
          id: profileData.idClaro,
          email: profileData.correo,
          phone_customer: stepInfo?.celebrated?.phone_customer || null
        },
        event: {
          id: select_event.category.id,
          other_event: select_event.category.label || null,
        },
        plan_id: select_plan.plan,
        celebrate_labels: celebrated.celebrate_labels,
        address: address && select_plan.plan === 1
          ? {
            address_id: address.id,
            name: address.nombre,
            street: address.calle,
            number: address.numeroExterior,
            internal_number: address.numeroInterior || null,
            suburb: address.colonia,
            zip_code: address.codigoPostal,
            state: address.estado,
            city: address.ciudad,
            town: address.municipio,
            references: address.referencias,
            between_streets: address.entreCalles,
            phone: address.telefono
          }
          : null,
        event_date: special_date.event_date,
        guest_range_id: guests.guests,
        gift_table: {
          name: giftTableName,
        },
        thanks_message: {
          type_id: TYPE_ID,
        },
        showing_purchased_products: planSelected,
      };

      if (celebrated.responsable_name) {
        saveTableBody.responsable_name = celebrated.responsable_name;
        saveTableBody.responsable_last_name = celebrated.responsable_last_name;
      }

      if (agentStaffId) {
        saveTableBody.agent_staff_id = agentStaffId;
      }

      // console.log('Esto se manda al servici: ',saveTableBody )
      dispatch(saveGiftTables(saveTableBody, onSaveError));

    }
    if (stepInfo){
      const applyBonification = !!stepInfo?.select_event?.category?.applyBonification ;
      setShowDisclaimer(!applyBonification);
    }
  }, [stepInfo, lastStep]);


  const handleClickDisabledNext = () => {
    setShowErrorModal(true);
  };

  const handleCloseModalError = () => {
    setShowErrorModal(false);
  };

  // const currentStepInfo = stepInfo[activeStep.key];
  const currentStepInfo = stepInfo[activeStep.key] ?? stepInfo.select_event;

  const disabledNext = currentStepInfo ? !currentStepInfo.plan : true;

  // console.log('---------------------');
  // console.log('steps: ', steps);
  // console.log('activeStep: ', activeStep);
  // console.log('stepInfo: ', stepInfo);
  // console.log('currentStepInfo: ', currentStepInfo);
  // console.log('disabledNext: ', disabledNext);


  useEffect(()=>{
    if(chanteStep){
      // console.log('activeStep: ', activeStep)
      // console.log('setCurrentStep: ',chanteStep)
      dispatch(setCurrentStep(chanteStep));
    }
  },[chanteStep])


  return (
    <>
      <style>
        {`
        .icono-arrow-right {
          color: white !important;
          position: relative;
          display: inline-block;
          vertical-align: middle;
          color: #666;
          box-sizing: border-box;
          width: 12px;
          height: 12px;
          border-width: 0.13625rem 0.13625rem 0 0;
          border-style: solid;
          margin: 12px 10px 10px 10px;
          transform: rotate(-135deg);
        }
        .icono-arrow-right::before {
          content: "";
          box-sizing: border-box;
          right: 0;
          top: -0.12rem;
          position: absolute;
          height: 2px;
          box-shadow: inset 0 0 0 32px;
          transform: rotate(-45deg);
          width: 18px;
          transform-origin: right top;
        }

        .icono-arrow-right::after {
          content: "";
          box-sizing: border-box;
        }

        `}
      </style>
      <ErrorModal
        show={showErrorModal}
        title={_get(activeStep, 'errorMessages.title', '')}
        subtitle={_get(activeStep, 'errorMessages.subtitle', '')}
        onClose={handleCloseModalError}
        onAction={handleCloseModalError}
        actionLabel="Seleccionar"
        type="single"
      />

      <div className={agentStaffId ? 'd-none' : ''}>
        <Header type="complete" />
      </div>

      <main
        className={`gifts-root animate__animated ${animation} animate__fast`}
      >
        <div className="table">
          <div className="table_header mb-md-2">
            {isMobile && (
            <div
              style={{ 
                borderBlockEnd: '1px solid rgb(222, 221, 221)',
                marginBottom: '1rem',
                display: 'flex',
                position: 'relative',
                top: '-24px',
                height: '56px',
                }}
            >

              {steps[0].key !== activeStep.key && (
                <div>
                  <div
                    style={{
                      borderRadius: '50%',
                      backgroundColor: 'red',
                      width: '35px',
                      height: '35px',
                      position: 'relative',
                      textAlign: 'center',
                      fontSize: '10px',
                      textAlignLast: 'center',
                      margin: '10px 10px 10px 10px',
                      marginRight: '10px',
                      display: 'flex',
                      cursor: 'pointer',
                    }}
                    onClick={handleBack}
                  >
                      <div className='icono-arrow-right' />
                  </div>
                </div>
              )}


             {activeStep.key == 'select_event'  && (
                <div>
                  <div
                    style={{
                      borderRadius: '50%',
                      backgroundColor: 'red',
                      width: '35px',
                      height: '35px',
                      position: 'relative',
                      textAlign: 'center',
                      fontSize: '10px',
                      textAlignLast: 'center',
                      margin: '10px 10px 10px 10px',
                      marginRight: '10px',
                      display: 'flex',
                      cursor: 'pointer',
                    }}
                    onClick={handleBackPage}
                  >
                      <div className='icono-arrow-right' />
                  </div>
                </div>
              )}
                
              <div style={{display: 'grid',
                alignItems: 'center',
                alignContent: 'center',
                position: 'relative',
                textAlign: 'center',
                textAlignLast: 'center',
                color: '#7c7676',
                verticalAlign: 'middle',
                paddingRight: (steps[0].key !== activeStep.key) ? '45px' : '0px', 
                width:'100%'}}>
                {activeStep.navHeader}
              </div>
            </div>)
            }
            <p className="table_breadcrumb">
              {chanteStep || activeStep.order} de {steps.length +1}
            </p>
            {/*
            <Image
              className="table_icon"
              src={activeStep.icon || giftIcon}
              alt="Creación de mesa de regalos"
            />
            */}
            <h4 className=" table_title mt-lg-1 mt-md-2">
              {activeStep.label}
            </h4>
          </div>

          <Container className="table_flow_wrapper py-1">
            <div className="content">
              <activeStep.component
                updateStep={setChanteStep}
                handleBack={handleBack}
                handleNext={handleNext}
                values={stepInfo[activeStep.key]}
                giftTableFlowValues={stepInfo[activeStep.key]}
                valueComplete={stepInfo}
                onSaveData={onSaveDataHandler}
                handlerPlan={handlerPlan}
              />
            </div>
          </Container>
          {}

          {(!isMobile && !activeStep.selfSubmit) && (
            <div className="table_flow_buttons">
              {steps[0].key !== activeStep.key && (
                <Button
                  variant="secondary"
                  className="btn-with-shadow"
                  onClick={handleBack}
                >
                  Atrás
                </Button>
              )}
              <Button
                disabled={disabledNext && !activeStep.errorMessages}
                className={
                  disabledNext && activeStep.errorMessages ? 'btn-disabled' : ''
                }
                onClick={disabledNext ? handleClickDisabledNext : handleNext}
              >
                Siguiente
              </Button>
            </div>
          )}

          {showDisclaimer && activeStep.order === 2 && (
            <div className='table_disclaimer'>
              <p>Este evento <span className='customColor'>no tiene bonificación a monedero</span> por cierre de evento. Pero puede ser acreedor a un regalo de cierre si llega a un monto mínimo de 3 compras en su evento. <br />(monto mínimo acumulado de $5,000 pesos)</p>
              </div>
          )}
        </div>
      </main>

      {!agentStaffId && <Footer type="complete" />}
    </>
  );
};

export default TableFlow;
